// src/index.js (or main.js)
import React from 'react';
import ReactDOM from 'react-dom/client'; // React 18+
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import App from './App';
import './index.css'; // Import the global CSS file, which includes Tailwind and custom styles

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter> {/* Wrap the app in BrowserRouter */}
    <App />
  </BrowserRouter>
);
